import { render, staticRenderFns } from "./ColumnChartTotalQualities.vue?vue&type=template&id=36311f1e"
import script from "./ColumnChartTotalQualities.vue?vue&type=script&lang=js"
export * from "./ColumnChartTotalQualities.vue?vue&type=script&lang=js"
import style0 from "./ColumnChartTotalQualities.vue?vue&type=style&index=0&id=36311f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports